<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import jquery from 'jquery'
window.$ = window.jQuery = jquery
require('bootstrap/dist/js/bootstrap.min')
require('jquery-mask-plugin/dist/jquery.mask.min')
export default {
  name: 'App',
  methods: {
    ...mapActions([
      'setUser',
      'setToken'
    ])
  },
  mounted () {
    if (window.sessionStorage.getItem('user') && window.sessionStorage.getItem('token')) {
      this.setUser(JSON.parse(window.sessionStorage.getItem('user')))
      this.setToken(window.sessionStorage.getItem('token'))
    }
  }
}
</script>

<style>
@import './assets/css/bootstrap.min.css';
@import '../node_modules/font-awesome/css/font-awesome.min.css';
@import '../node_modules/animate.css/animate.css';
@import '../node_modules/sweetalert2/dist/sweetalert2.css';
@import './assets/css/app.css';
.swal2-popup {
  font-size: 1.6rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue